import React, {useEffect, useState} from 'react';

const Placeholder = ({mea, isAutoPromoBanners, listType, apiStatusPending}) => {
    const [display, setDisplay] = useState('none');
    useEffect(() => {
        let displayValue = apiStatusPending ? listType === 'grid' ? 'block' : 'flex' : 'none'
        if (display !== displayValue) {
            setDisplay(displayValue)
        }
    }, [apiStatusPending])

    return (
        <div style={{display: display}} className={`shimmer-col list-type-${listType}  ${mea ? mea : ''} ${isAutoPromoBanners}`}>
            <div className="shimmer-card">
                <div className>
                    <div className="shimmer shimmer-thumbnail mb-0" />
                </div>
                {!!mea ||
                    <div className="p-30">
                        <div className="grid shimmer-title--secondary grid-gap-10">
                            <div className="shimmer shimmer-title-line" />
                            <div className="shimmer shimmer-title-line" />
                        </div>
                        <div className="grid shimmer-text grid-gap-10">
                            <div className="shimmer shimmer-text-line" />
                            <div className="shimmer shimmer-text-line" />
                            <div className="shimmer shimmer-text-line" />
                        </div>
                        <div className="shimmer shimmer-button shimmer-button--sm" />
                    </div>
                }
            </div>
        </div>
    )
}

export default Placeholder;